import type { CrremCorrectionFlags } from "../model/types";

const CORRECTION_KEYS = ["coverage", "climate", "vacancy"] as const;

export const formatCrremScenarioLabel = (key: string) => {
  if (!key.startsWith("target_")) return key;
  return `CRREM ${key.slice("target_".length).replace(/_/g, ".")}°C`;
};

const stripCorrectedTerm = (label: string) =>
  label.replace(/\s*Corrected\s*/gi, " ").replace(/\s+/g, " ").trim() || label;

export const formatCorrectionLabel = (corrections: CrremCorrectionFlags, fallback: string) => {
  const parts = CORRECTION_KEYS.filter((key) => corrections[key]).map((key) => key[0].toUpperCase() + key.slice(1));
  return parts.join(" + ") || stripCorrectedTerm(fallback);
};

export const toSafeChartSeriesName = (name: string) => name.replace(/\+/g, "\uFF0B");
